<script>
export default {
  data() {
    return {
      scrollPosition: 0,
      shrinkingHeaderHeight: 0,
      pageContentTop: 0,
      stickyHeaderHeight: 0,
      pagePaddingTop: 0,
      reachedBottom: false
    };
  },

  mounted() {
    window.addEventListener('scroll', this.updateScroll);
    this.computeStickyHeaderHeight();
    window.addEventListener('DOMContentLoaded', this.computeShrinkingHeaderHeight());
    this.pagePaddingTop = this.shrinkingHeaderHeight + 40 + 'px';
    window.addEventListener('resize', this.computeContentsTop());
  },

  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY;

      if (window.scrollY > 0) {
        this.computeContentsTop();
      }
      if (Math.round(window.scrollY + window.innerHeight) >= document.body.scrollHeight - 20) {
        this.reachedBottom = true;
      } else {
        this.reachedBottom = false;
      }
    },
    computeStickyHeaderHeight() {
      let stickyHeader = document.getElementById('sticky-header');
      this.stickyHeaderHeight = stickyHeader.offsetHeight;
    },
    computeShrinkingHeaderHeight() {
      let header = document.getElementById('shrinking-header');
      this.shrinkingHeaderHeight = header.offsetHeight;
    },
    computeContentsTop() {
      this.computeShrinkingHeaderHeight();
      this.pageContentTop = this.shrinkingHeaderHeight + this.stickyHeaderHeight + 40 + 'px';
    }
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.updateScroll);
  }
};
</script>
